import { render, staticRenderFns } from "./SetUp.vue?vue&type=template&id=39e8c20e&scoped=true&"
import script from "./SetUp.vue?vue&type=script&lang=js&"
export * from "./SetUp.vue?vue&type=script&lang=js&"
import style0 from "./SetUp.vue?vue&type=style&index=0&id=39e8c20e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e8c20e",
  null
  
)

export default component.exports